import Allergy from '../classes/Allergy'

export default class AllergyFoodPatientHistoryDetails {
    constructor(
        public newValues?: Allergy,
        public oldValues?: Allergy,
    ) {}
}
